import { statusIndicatorDriverFactory } from '../StatusIndicator/StatusIndicator.uni.driver';
import { dataHooks } from './constants';
import publicDriverFactory from './Input.uni.driver';
import { ReactBase } from '../test-utils/utils/unidriver';

export const testkit = (base, body) => {
  const input = base.$$('input').get(0);
  const reactBaseInput = ReactBase(input);

  return {
    ...publicDriverFactory(base, body),

    startComposing: () => reactBaseInput._private.compositionStart(),
    endComposing: () => reactBaseInput._private.compositionEnd(),
    statusIndicatorExists: async () => {
      const statusIndicatorDriver = statusIndicatorDriverFactory(
        base.$(`[data-hook="${dataHooks.status}"]`),
        body,
      );
      return statusIndicatorDriver.exists();
    },
  };
};
